"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      display: 'flex',
      justifyContent: 'center',
      height: 51
    }, theme.breakpoints.up('xs'), {
      height: 58
    }),
    input: _defineProperty({
      width: 34,
      height: 24,
      margin: theme.spacing(0, 0.5)
    }, theme.breakpoints.up('xs'), {
      width: 47
    }),
    inputElement: _defineProperty({
      textAlign: 'center',
      fontSize: '0.75rem'
    }, theme.breakpoints.up('xs'), {
      fontSize: '1.125rem'
    })
  };
};

var _default = styles;
exports.default = _default;